var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-bd",class:[{'fixed':_vm.fixed},{'radius':_vm.radius}],on:{"click":_vm.onChange}},[_c('p',{class:[{'disabled': _vm.disabled },{'small': _vm.size === 'small'}]},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29c1db46","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/button.vue
// module id = null
// module chunks = 